import React, { FC, useState } from 'react';
import { useTranslations } from '@lang';
import FeaturedItem from '@common/components/FeaturedItem';
import Markdown from '@common/components/Markdown';
import { Heading4 } from '@common/components/Typography';
import SectionContainer from '@common/components/SectionContainer';
import { Routes } from '@common/constants';
import { Category, JourneyParams } from 'shared-types/Common';
import { DatePicker } from '@features/JourneyPicker';
import moment, { Moment } from 'moment';
import {
  CategoryViewWrapper,
  GridWrapper,
  StyledPageDescription,
  StyledPageTitleContainer,
} from './SpaDaysCategoryView.styles';
import { useLabels } from '@features/Menu/useLabels';

type SpaDaysCategoryViewProps = {
  spaDaysPage: {
    title?: string;
    content?: string;
  };
  categories: Category[];
  journeyParams: JourneyParams;
  changeJourneyParam: (dateId: string, date?: string | Moment | number) => void;
};

export const SpaDaysCategoryView: FC<SpaDaysCategoryViewProps> = ({
  categories = [],
  spaDaysPage = {
    title: '',
    heroBackgroundImage: null,
    content: '',
  },
  journeyParams,
  changeJourneyParam,
}) => {
  const { t } = useTranslations();
  const labels = useLabels();
  const [date, setDate] = useState(journeyParams.fromDate);

  const updateJourneyParams = (date) => {
    changeJourneyParam('fromDate', date);
    changeJourneyParam('spaDate', date);
  };

  return (
    <CategoryViewWrapper>
      <SectionContainer>
        <DatePicker
          fromDate={moment(date)}
          handleUpdate={() => {
            updateJourneyParams(date);
          }}
          onDateChange={setDate}
        />
      </SectionContainer>
      <SectionContainer>
        {spaDaysPage && spaDaysPage.title ? (
          <StyledPageTitleContainer>
            <Heading4 tag="h1">{spaDaysPage.title}</Heading4>
          </StyledPageTitleContainer>
        ) : (
          labels?.spadays || t('spaDaysLisiting.spaDays')
        )}
        {spaDaysPage && spaDaysPage.content && (
          <StyledPageDescription>
            <Markdown text={spaDaysPage.content} />
          </StyledPageDescription>
        )}
        <GridWrapper>
          {categories.map((category) => (
            <FeaturedItem
              key={category.id}
              title={category.name}
              height={310}
              imageUrl={category.image && category.image.url}
              redirectData={{
                pathname: Routes.SPA_DAY_CATEGORY_DETAIL,
                query: {
                  id: category.id,
                },
              }}
            >
              <h2>{category.name}</h2>
            </FeaturedItem>
          ))}
        </GridWrapper>
      </SectionContainer>
    </CategoryViewWrapper>
  );
};
